import { useI18n } from 'vue-i18n'
import columnStore from '@/stores/column'

export default function useJournalColumns(component: string) {
	const i18n = useI18n()
	const cols = columnStore()

	const table = cols.define(component, 'table', i18n.t('misc.table'), true)
	const rowId = cols.define(component, 'rowId', i18n.t('misc.table'), true)
	const rowId2 = cols.define(component, 'rowId2', i18n.t('misc.table'), true)

	const columns = { table, rowId, rowId2 }

	const { all } = cols.finalize(component, columns, false)

	return { columns, all }
}
